import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { assignCrmStaff, getProviderStaff } from "../../../../store/crm/staff";
import {
    changeAppointmentStatus,
    getAllAppointment,
    getAppointmentDetails,
    getAppointmentHistory,
    getAppointmentcalender
} from "../../../../store/crm/appointment";
import CustomButtoncolor from "../../../../components/custom-button/customColorButton";
import Box from "@mui/material/Box";
import {
    Avatar, Button, Checkbox, FormControlLabel, FormGroup, Grid, IconButton, Typography, Drawer
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router";
import Waveloading from '../../../loading/Waveloading';
import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Cancel';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { apiHeaders } from "../../../../lib/apiHeader";
import { getCRMCustomerBookingsDetails } from '../../../../store/crm/crm';
import toast from 'react-hot-toast';
import { BACKEND_URL } from "../../../../config";
import { customConfirmation } from "../../../../services/utills";

const PRIMARY = "#A72C68";
const PRIMARY_LIGHT = "#FAEFF5";
const PRIMARY_BORDER = "#F0CDDB";
const PRIMARY_GRADIENT = "linear-gradient(135deg,#A72C68 0%,#921F58 100%)";

const AppointmentStaffStatus = ({
    isbtn,
    appointment,
    label,
    isFetch,
    isAppointment,
    value,
    isNoShow,
    mainColor,
    fetchAppointment,
    fetchCalenderBookings,
    fwidth,
    onRescheduleSuccess,
}) => {
    const [loading, setLoading] = useState(false);
    const [panelLoading, setPanelLoading] = useState(false);
    const [staffModal, setStaffModal] = useState(false);
    const [selectedStaff, setSelectedStaff] = useState(null);

    const isStaff = value === 'CheckIn' && !appointment?.staff?.id;
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const crmStaffStore = useSelector(state => state?.crmStaffStore);
    const { crmStaffs = [] } = crmStaffStore;

    const scrollRef = useRef(null);

    useEffect(() => {
        (async () => {
            if (!crmStaffs?.length && staffModal && (value === 'CheckIn' || !value)) {
                setPanelLoading(true);
                await dispatch(getProviderStaff());
                setPanelLoading(false);
            }
        })();
    }, [staffModal]);

    const handleOpen = () => {
        if (appointment?.id && !value) {
            if (appointment?.staff?.id) {
                setSelectedStaff(appointment?.staff);
            } else {
                setSelectedStaff(null);
            }
        }
        setStaffModal(true);
    };

    const handleClose = () => {
        setSelectedStaff(null);
        setStaffModal(false);
    };

    const handleAssign = async (staffOverride) => {
        if (appointment?.id) {
            setPanelLoading(true);
            const staffForAssign = staffOverride !== undefined ? staffOverride : selectedStaff;
            let finalData = {
                appointment_id: appointment?.id,
                staff_id: staffForAssign ? staffForAssign?.id : null,
            };

            if (isStaff) {
                finalData['status'] = 'CheckIn';
            }
            let res = await dispatch(assignCrmStaff(finalData));
            if (res?.payload?.success === 'true') {
                if (isAppointment) {
                    await dispatch(getAppointmentHistory({
                        user_id: appointment?.customer?.id, type: 'Appointments'
                    }));
                    await dispatch(getCRMCustomerBookingsDetails({ id: appointment?.customer?.id, type: 'Appointments' }));
                }

                if (isFetch) {
                    await dispatch(getAppointmentDetails(appointment?.id));
                    await dispatch(getAllAppointment());
                }
                if (fetchAppointment) {
                    await fetchAppointment();
                }
                if (fetchCalenderBookings) {
                    await fetchCalenderBookings();
                    await dispatch(getAppointmentcalender(appointment?.id));
                }

                toast.success(
                    isStaff
                        ? 'Staff assigned and checked in successfully!'
                        : "Staff assigned successfully!"
                );
                handleClose();
            }

            setPanelLoading(false);
        }
    };

    const handelremoveStaff = async () => {
        if (appointment?.id) {
            setPanelLoading(true);

            let finalData = {
                appointment_id: appointment?.id,
                staff_id: selectedStaff ? selectedStaff?.id : null,
            };

            if (isStaff) {
                finalData['status'] = 'CheckIn';
            }

            const API_ENDPOINT = `${BACKEND_URL}crm/appointments/remove-staff`;

            try {
                const res = await fetch(API_ENDPOINT, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...apiHeaders(),
                    },
                    body: JSON.stringify(finalData),
                });

                const result = await res.json();
                if (result?.success === 'true') {
                    await dispatch(getAppointmentcalender(appointment?.id));
                    if (isFetch) {
                        await dispatch(getAppointmentDetails(appointment?.id));
                    } else {
                        dispatch(getAppointmentDetails(appointment?.id));
                    }
                    if (fetchCalenderBookings) {
                        await fetchCalenderBookings();
                    }

                    await dispatch(getAllAppointment({ start_date: "null", end_date: "null" }));
                    if (fetchAppointment) {
                        await fetchAppointment();
                    }
                    await dispatch(getAppointmentHistory({
                        user_id: appointment?.customer?.id, type: 'Appointments'
                    }));
                    await dispatch(getCRMCustomerBookingsDetails({
                        id: appointment?.customer?.id, type: 'Appointments'
                    }));
                    toast.success("Assigned staff remove successfully.");
                    handleClose();
                }
            } catch (error) {
                console.error("Error in removeCrmStaff:", error);
            }

            setPanelLoading(false);
        }
    };

    const handleStaffCheckboxClick = async (e, staff) => {
        e.stopPropagation();
        const wasSelected = selectedStaff?.id === staff.id;
        if (wasSelected) {
            setSelectedStaff(null);
            if (appointment?.staff?.id === staff.id) {
                await handelremoveStaff();
            }
        } else {
            setSelectedStaff(staff);
            await handleAssign(staff);
        }
    };

    function getConfirm(label) {
        switch (label) {
            case "Cancel/Refund": return "Cancel / Refund ";
            case "Check-Out": return "Check Out";
            case "Mark as No Show": return "No Show ";
            case "No Show": return "No Show ";
            case "Check-In": return "Check In ";
            default: return "Confirm Appointment";
        }
    }

    function getConfirmSuccessMessage(label) {
        switch (label) {
            // Don't claim a refund was processed — this endpoint only changes the
            // appointment status; any refund is handled separately.
            case "Cancel/Refund": return "Appointment canceled successfully!";
            case "Check-Out": return "Checkout completed successfully!";
            case "Mark as No Show":
            case "No Show": return "Marked as No-Show successfully!";
            case "Check-In": return "Checked in successfully!";
            default: return "Appointment confirmed successfully!";
        }
    }

    function getIcon(label) {
        switch (label) {
            case "Cancel/Refund": return <CancelIcon />;
            case "Check-Out": return <CheckCircleIcon />;
            case "Mark as No Show":
            case "No Show": return <HighlightOffIcon />;
            case "Check-In": return <CheckCircleIcon />;
            default: return <PersonAddIcon />;
        }
    }

    const handleChangeStatus = async () => {
        if (isStaff) {
            handleOpen();
            return;
        }

        if (!appointment?.id) return;

        const finalData = {
            appointment_id: appointment?.id,
            status: value,
        };

        if (value === 'CheckOut') {
            navigate(`/crm/appointment/checkout/${appointment?.id}`);
            return;
        }

        // Cancelling is destructive and can't be undone from here, so confirm
        // first — the calendar variant of this button already does.
        if (value === 'Canceled') {
            const confirmed = await customConfirmation(
                'Cancel this appointment?',
                "The appointment will be marked as canceled. This can't be undone.",
                'Yes, cancel it',
                'Keep appointment',
                true
            );
            if (!confirmed) return;
        }

        setLoading(true);
        const res = await dispatch(changeAppointmentStatus(finalData));

        if (res?.payload?.success === "true") {
            if (isFetch) {
                await dispatch(getAppointmentDetails(appointment?.id));
                await dispatch(getAllAppointment());
            }
            if (fetchAppointment) {
                await fetchAppointment();
            }

            if (fetchCalenderBookings) {
                await dispatch(getAppointmentcalender(appointment?.id));
                await fetchCalenderBookings();
            }

            if (isAppointment) {
                await dispatch(getAppointmentHistory({ user_id: appointment?.customer?.id, type: 'Appointments' }));
                await dispatch(getCRMCustomerBookingsDetails({ id: appointment?.customer?.id, type: 'Appointments' }));
            }

            await dispatch(getAllAppointment());

            if (onRescheduleSuccess) {
                onRescheduleSuccess();
            }

            toast.success(getConfirmSuccessMessage(label));
        } else {
            toast.error(res?.payload?.message || res?.payload?.errors || 'Could not update the appointment. Please try again.');
        }

        setLoading(false);
    };

    const handleCheckbox = async (e) => {
        const { checked } = e.target;
        if (checked) {
            await handleChangeStatus();
        }
    };

    const handleStaffSelection = (staff) => {
        if (selectedStaff?.id === staff.id) {
            setSelectedStaff(null);
        } else {
            setSelectedStaff(staff);
        }
    };

    return (
        <Box>
            {loading ? <Waveloading fullSize /> : ''}
            {value ? (
                <Box>
                    {isNoShow ? (
                        <FormGroup>
                            <FormControlLabel
                                control={<Checkbox onChange={(e) => handleCheckbox(e)} />}
                                label={label}
                            />
                        </FormGroup>
                    ) : mainColor ? (
                        <CustomButtoncolor
                            handleClick={() => handleChangeStatus()}
                            mainColor={mainColor}
                            style={{ borderRadius: "4px", padding: "10px 15px", width: fwidth }}
                            val={isbtn ? getConfirm(label) : label}
                            icon={isbtn ? getIcon(label) : null}
                        />
                    ) : (
                        <CustomButtoncolor
                            handleClick={() => handleChangeStatus()}
                            style={{ borderRadius: "4px", padding: "10px 15px", width: fwidth }}
                            val={isbtn ? getConfirm(label) : label}
                            icon={isbtn ? getIcon(label) : null}
                        />
                    )}
                </Box>
            ) : (
                <Box>
                    <CustomButtoncolor
                        style={{ borderRadius: "4px", padding: "10px 15px", width: fwidth }}
                        mainColor={"#323681"}
                        val={appointment?.staff?.id ? "Edit Staff" : "Assign Staff"}
                        handleClick={() => handleOpen()}
                        icon={
                            isbtn
                                ? appointment?.staff?.id
                                    ? <EditIcon />
                                    : <PersonAddIcon />
                                : null
                        }
                        size={"medium"}
                    />
                </Box>
            )}

            <Drawer
                anchor="right"
                open={staffModal}
                onClose={handleClose}
                PaperProps={{
                    sx: {
                        width: { xs: '100%', sm: 540, md: 620, lg: 680 },
                        maxWidth: '100vw',
                        background: '#fff',
                        boxShadow: '-12px 0 40px rgba(0,0,0,0.10)',
                    },
                }}
            >
                <Box sx={{ position: 'relative', display: 'flex', flexDirection: 'column', height: '100%', background: '#fff' }}>
                    {panelLoading && (
                        <Box
                            sx={{
                                position: 'absolute',
                                inset: 0,
                                background: 'rgba(255, 255, 255, 0.75)',
                                zIndex: 20,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Waveloading />
                        </Box>
                    )}
                    {/* Header */}
                    <Box
                        sx={{
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: 1.25,
                            px: 2.5,
                            py: 2,
                            borderBottom: '1px solid #F1F2F6',
                            flexShrink: 0,
                        }}
                    >
                        <Box
                            sx={{
                                width: 42,
                                height: 42,
                                borderRadius: '10px',
                                background: '#F4DDE8',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                            }}
                        >
                            <PersonAddIcon sx={{ color: PRIMARY, fontSize: 22 }} />
                        </Box>
                        <Box sx={{ flex: 1, pr: 3 }}>
                            <Typography sx={{ fontWeight: 700, fontSize: '18px', color: '#1a1a2e', lineHeight: 1.2, fontFamily: 'helvetica-lt-std-bold,sans-serif' }}>
                                {appointment?.staff?.id ? 'Edit Staff' : 'Assign Staff'}
                            </Typography>
                            <Typography sx={{ fontSize: '12px', color: '#8a8d97', mt: '2px' }}>
                                Select staff members to assign.
                            </Typography>
                        </Box>
                        <IconButton
                            size="small"
                            onClick={handleClose}
                            sx={{
                                position: 'absolute',
                                top: 10,
                                right: 10,
                                color: '#9A9797',
                                '&:hover': { color: '#EB5757', background: '#ffeaea' },
                            }}
                        >
                            <CloseIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                    </Box>

                    <Box sx={{ flex: 1, overflow: 'auto', p: 2.5 }}>
                        {/* Action buttons on top */}
                        <Box sx={{ display: 'flex', gap: 1, mb: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={() => handleAssign()}
                                startIcon={appointment?.staff?.id
                                    ? <EditIcon sx={{ fontSize: '16px !important' }} />
                                    : <PersonAddIcon sx={{ fontSize: '18px !important' }} />}
                                sx={{
                                    background: PRIMARY, color: '#fff',
                                    textTransform: 'none', borderRadius: '10px', py: 1.25,
                                    fontWeight: 600, fontSize: '13px',
                                    boxShadow: '0 2px 6px rgba(167,44,104,0.25)',
                                    '&:hover': { background: '#921F58' },
                                }}
                            >
                                {isStaff ? 'Assign Staff and Check-In' : (appointment?.staff?.id ? 'Update Staff' : 'Add Staff')}
                            </Button>
                            <Button
                                fullWidth
                                variant="outlined"
                                disabled={!appointment?.staff?.id}
                                onClick={() => handelremoveStaff()}
                                sx={{
                                    color: '#EB5757',
                                    borderColor: '#FFD3D3',
                                    background: '#FFF5F5',
                                    textTransform: 'none',
                                    borderRadius: '10px',
                                    py: 1.25,
                                    fontWeight: 600,
                                    fontSize: '13px',
                                    '&:hover': { background: '#FFEAEA', borderColor: '#EB5757' },
                                    '&.Mui-disabled': { color: '#d3b5b5', background: '#FFF5F5', borderColor: '#FFE0E0' },
                                }}
                            >
                                Remove Staff
                            </Button>
                        </Box>

                        {isStaff && (
                            <Typography
                                sx={{
                                    color: '#EB5757',
                                    textAlign: 'center',
                                    mb: 2,
                                    fontSize: '12px',
                                    fontWeight: 600,
                                }}
                            >
                                Please choose staff and then Check-In
                            </Typography>
                        )}

                        {/* Staff grid */}
                        {crmStaffs?.length > 0 ? (
                            <Grid container spacing={1.5}>
                                {crmStaffs.map((staff, index) => {
                                    const isSelected = selectedStaff?.id === staff?.id;
                                    return (
                                        <Grid item xs={6} sm={6} md={4} lg={3} key={index}>
                                            <Box
                                                onClick={() => handleStaffSelection(staff)}
                                                sx={{
                                                    position: 'relative',
                                                    cursor: 'pointer',
                                                    background: '#fff',
                                                    border: isSelected ? `2px solid ${PRIMARY}` : '1px solid #F0F1F4',
                                                    borderRadius: '12px',
                                                    overflow: 'hidden',
                                                    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
                                                    transition: 'border-color 0.15s, box-shadow 0.15s',
                                                    '&:hover': {
                                                        borderColor: PRIMARY,
                                                        boxShadow: '0 4px 10px rgba(167,44,104,0.10)',
                                                    },
                                                }}
                                            >
                                                <Box
                                                    role="checkbox"
                                                    aria-checked={isSelected}
                                                    onClick={(e) => handleStaffCheckboxClick(e, staff)}
                                                    sx={{
                                                        position: 'absolute',
                                                        top: 8,
                                                        right: 8,
                                                        zIndex: 2,
                                                        width: 22,
                                                        height: 22,
                                                        borderRadius: '6px',
                                                        background: isSelected ? PRIMARY : 'rgba(255,255,255,0.95)',
                                                        border: isSelected ? `1px solid ${PRIMARY}` : '1px solid #d6d8de',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        cursor: 'pointer',
                                                        boxShadow: isSelected
                                                            ? '0 2px 4px rgba(167,44,104,0.30)'
                                                            : '0 1px 2px rgba(0,0,0,0.08)',
                                                        transition: 'transform .12s ease, box-shadow .12s ease',
                                                        '&:hover': {
                                                            transform: 'scale(1.08)',
                                                            boxShadow: isSelected
                                                                ? '0 3px 6px rgba(167,44,104,0.40)'
                                                                : '0 2px 4px rgba(0,0,0,0.14)',
                                                        },
                                                    }}
                                                >
                                                    {isSelected && <CheckCircleIcon sx={{ color: '#fff', fontSize: 16 }} />}
                                                </Box>
                                                <Box sx={{ width: '100%', aspectRatio: '1 / 1', overflow: 'hidden', background: '#F4F5F8' }}>
                                                    <Avatar
                                                        src={staff?.profile_image}
                                                        variant="square"
                                                        sx={{ width: '100%', height: '100%' }}
                                                    />
                                                </Box>
                                                <Typography
                                                    sx={{
                                                        py: 1.25,
                                                        px: 1,
                                                        fontSize: '13px',
                                                        fontWeight: 600,
                                                        color: '#1a1a2e',
                                                        textAlign: 'center',
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                    }}
                                                >
                                                    {staff?.name}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        ) : (
                            <Typography sx={{ textAlign: 'center', mt: '24px', color: '#9ca3af', fontSize: '13px' }}>
                                No Staff Found
                            </Typography>
                        )}
                        <Box ref={scrollRef} />
                    </Box>
                </Box>
            </Drawer>

        </Box>
    );
};

export default AppointmentStaffStatus;
